import React, { FC, useEffect, useState } from 'react'
import { Main as MainLayout } from '../layouts'
import styles from 'pagestyles/ShopPodTwitterCard.module.scss'
import { useWindowSize } from 'components/_hooks/useWindowSize'
import { CTACard } from 'components/WallOfLove/CTACard'
import { ArticleCard, TweetCard, VideoCard } from 'components/WallOfLove'
import { CTAItem, WallOfLoveCategory } from 'components/WallOfLove/wallOfLoveIterfaces'
import { Filter } from 'components/WallOfLove/Filter'
import { items } from 'components/WallOfLove/wallOfLoveItems'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHeaderHeightObserver } from 'components/_hooks/useHeaderHeightObserver'
import { PropsWithRootStore } from 'constants/types'

type WallOfLoveProps = PropsWithRootStore

const getNumColumns = (windowInnerWidth: number) => {
	const padding = 32
	const gap = 32
	const cardWidth = 300

	//Consider the gap between cards as just a right margin on each card
	// set 1550 as the max width, beyond that remain at 4 columns
	const actualWidth = Math.min(windowInnerWidth, 1550) - padding

	return Math.max(1, Math.floor(actualWidth / (cardWidth + gap)))
}

const getCTAItem = (subtitle: string): CTAItem => {
	return {
		title: 'Sleep that turns you into a superfan',
		subtitle: subtitle,
		cta: 'Shop now',
		ctaLink: '/product/pod-cover',
		image: 'tattoo',
		categories: ['Familiar faces', 'Everyday love', 'Sleep improvement'],
	}
}

const NUM_ITEMS_TO_DISPLAY = 32
const AD_BASE_INTERVAL = 7
const AD_DISPLACEMENT = 5
const AD_INTERVAL_INCREASE_RATE = 1.3
const AD_MAX_INTERVAL = 40

const CTA_CARD_HEIGHT = 450
const ARTICLE_VIDEO_HEIGHT = 525
const TWEET_NO_IMAGE_HEIGHT = 223
const TWEET_IMAGE_HEIGHT = 600

const WallOfLove: FC<WallOfLoveProps> = (props) => {
	const { priceStore, settingsStore } = props.rootStore
	const { width } = useWindowSize()
	const [selectedFilter, setSelectedFilter] = React.useState<WallOfLoveCategory>('All')
	const [itemsToDisplay, setItemsToDisplay] = React.useState<number>(NUM_ITEMS_TO_DISPLAY)
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
	}, [])

	const changeCategories = (category: WallOfLoveCategory) => {
		setMounted(false)
		window.scrollTo({ top: 0, left: 0 })
		setTimeout(() => {
			setSelectedFilter(category)
			setItemsToDisplay(NUM_ITEMS_TO_DISPLAY)
			setMounted(true)
		}, 500)
	}

	const numColumns = getNumColumns(width)
	const columns = []
	for (let i = 0; i < numColumns; i++) {
		columns.push([])
	}

	const filteredItems = items.filter((item) => {
		return selectedFilter === 'All' || item.categories.indexOf(selectedFilter) !== -1
	})

	const limitItems = filteredItems.slice(0, itemsToDisplay)

	const discountAmount = priceStore.discountFormatted

	// Insert adsš
	// let ad_interval = AD_BASE_INTERVAL
	// for (let i = AD_DISPLACEMENT; i < limitItems.length; i += ad_interval) {
	// 	limitItems.splice(i, 0, getCTAItem(`Join the movement and upgrade your sleep with up to ${discountAmount} off the Pod.`))
	// 	// increase interval
	// 	ad_interval *= AD_INTERVAL_INCREASE_RATE
	// 	ad_interval = Math.round(ad_interval)
	// 	ad_interval = Math.min(ad_interval, AD_MAX_INTERVAL)
	// }

	// Place items
	const columnHeights = []
	for (let i = 0; i < numColumns; i++) {
		columnHeights.push(0)
	}

	for (let i = 0; i < limitItems.length; i++) {
		const approximateHeight = getApproximateHeight(limitItems[i])
		const columnIndex = columnHeights.indexOf(Math.min(...columnHeights))
		columns[columnIndex].push(processItem(limitItems[i], i, settingsStore.settings.saleName))
		columnHeights[columnIndex] += approximateHeight
	}

	return (
		<MainLayout>
			<div className={styles.container}>
				<h1 className={styles.heading}>Sleep you can't stop talking about</h1>
				<div
					className={styles.filter_container}
					style={{
						top: useHeaderHeightObserver() + 'px',
					}}
				>
					<Filter
						items={['All', 'Familiar faces', 'Everyday love', 'Sleep improvement']}
						selectItem={changeCategories}
						defaultItem={'All'}
					/>
				</div>
				<div
					className={styles.inner}
					style={{
						opacity: mounted ? 1 : 0,
					}}
				>
					<InfiniteScroll
						scrollThreshold={0.7}
						next={() => setItemsToDisplay((prev) => prev + NUM_ITEMS_TO_DISPLAY)}
						hasMore={itemsToDisplay < items.length}
						loader={<></>}
						dataLength={itemsToDisplay}
					>
						<div className={styles.columns}>
							{columns.map((column, i) => (
								<div
									key={i}
									className={styles.column}
								>
									{column}
								</div>
							))}
						</div>
					</InfiniteScroll>
				</div>
			</div>
		</MainLayout>
	)
}

export default WallOfLove

const getApproximateHeight = (item: any) => {
	if (item.unixDateMS) {
		if (item.image) {
			return TWEET_IMAGE_HEIGHT
		} else {
			return TWEET_NO_IMAGE_HEIGHT
		}
	} else if (item.thumbnail || item.logo) {
		return ARTICLE_VIDEO_HEIGHT
	} else if (item.cta) {
		return CTA_CARD_HEIGHT
	}

	return 0
}

const processItem = (item: any, i: number, saleName: string) => {
	if (item.unixDateMS) {
		return (
			<TweetCard
				{...item}
				id={`wall-of-love-item-${i}`}
			/>
		)
	} else if (item.thumbnail) {
		return (
			<VideoCard
				{...item}
				id={`wall-of-love-item-${i}`}
			/>
		)
	} else if (item.logo) {
		return (
			<ArticleCard
				{...item}
				id={`wall-of-love-item-${i}`}
			/>
		)
	} else if (item.cta) {
		return (
			<CTACard
				{...item}
				id={`wall-of-love-item-${i}`}
				saleName={saleName}
			/>
		)
	}

	return null
}
